import Slider from "react-slick";

const CarouselWithArrows = () => {
  const settings = {
        dots: true,
        arrows: false,
        infinite: true,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
        autoplay: true,
        autoplaySpeed: 2000 // 2-second transition for auto image change
    };

  const imageUrl = "https://pub-7812b49fa5b340c8996586c6cb894da3.r2.dev/Plantation/large-1755774202461-President.webp";
  const imageUrl1 = "https://pub-7812b49fa5b340c8996586c6cb894da3.r2.dev/Plantation/large-1755665753687-1723028998.webp";
  const imageUrl2 = "https://pub-7812b49fa5b340c8996586c6cb894da3.r2.dev/Plantation/large-1755773975389-CMP.webp";
  const imageUrl3 = "https://pub-7812b49fa5b340c8996586c6cb894da3.r2.dev/Plantation/large-1755774401168-CMS.webp";
  const imageUrl4 = "https://pub-7812b49fa5b340c8996586c6cb894da3.r2.dev/Plantation/large-1755774643548-CMB.webp";
  const imageUrl5 = "https://pub-7812b49fa5b340c8996586c6cb894da3.r2.dev/ppms/image-1769084004218-cm-kpk.webp";
  

  return (
      <div className="card p-0 overflow-hidden position-relative radius-12">
        <div className="bg-base border border-end-0 border-start-0 border-top-0">
        </div>
        <div className="arrow-carousel">
          <Slider {...settings}>
            <div className="gradient-overlay bottom-0 start-0 h-100">
              <img
                src={imageUrl}
                alt="carousel-slide"
                className="w-100 h-100 object-fit-cover rounded"
              />
            </div>
            <div className="gradient-overlay bottom-0 start-0 h-100">
              <img
                src={imageUrl1}
                alt="carousel-slide"
                className="w-100 h-100 object-fit-cover rounded"
              />
            </div>
            <div className="gradient-overlay bottom-0 start-0 h-100">
              <img
                src={imageUrl2}
                alt="carousel-slide"
                className="w-100 h-100 object-fit-cover rounded"
              />
            </div>
            <div className="gradient-overlay bottom-0 start-0 h-100">
              <img
                src={imageUrl3}
                alt="carousel-slide"
                className="w-100 h-100 object-fit-cover rounded"
              />
            </div>
            <div className="gradient-overlay bottom-0 start-0 h-100">
              <img
                src={imageUrl4}
                alt="carousel-slide"
                className="w-100 h-100 object-fit-cover rounded"
              />
            </div>
            <div className="gradient-overlay bottom-0 start-0 h-100">
              <img
                src={imageUrl5}
                alt="carousel-slide"
                className="w-100 h-100 object-fit-cover rounded"
              />
            </div>
          </Slider>
        </div>
      </div>
  );
};

export default CarouselWithArrows;

